import { Component, type ComponentChildren } from 'preact';

interface Props { children: ComponentChildren; }
interface State { error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: any) {
    console.error('[shop-widget] Uncaught error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div class="alert alert-danger small m-2" role="alert">
          <strong>Widget error:</strong> {this.state.error.message}
        </div>
      );
    }
    return this.props.children;
  }
}
